module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/instagram/sola_sns_06-486fe654b411c160e6bc90d624a47a68.jpg";